var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"min-height":"400px"}},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"primary"}}),_c('p',{staticClass:"mt-3"},[_vm._v("Processing login...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }